import React, {useState , useEffect} from 'react';
import axios from './axios';
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";


const base_url = "https://image.tmdb.org/t/p/original/";

function Row({title ,fetchUrl,isLargeRow}) {
  const [movies, setMovies] = useState([]);
  const [trailerUrl , setTrailerUrl] = useState("");

  useEffect(() => {
    //if [], run once when the row loads, and dont run again.
    async function fetchData(){
      const request = await axios.get(fetchUrl);
      setMovies(request.data.results);
      return request;
    }
    fetchData();
  },[fetchUrl] );

  const opts = {
    height : '470',
    width : "100%",
    playerVars : {
       // https://developers.google.com/youtube/player_parameters
      autoplay : 1,
    }
  }

  const handleClick = (movie) => {
    if(trailerUrl){
      setTrailerUrl("")
    } else {
      movieTrailer(movie?.title || movie?.name || movie?.original_name || " ")
      .then((url) => {
        const urlParams = new URLSearchParams( new URL(url).search );
        // https://www.youtube.com/watch?v=uIdjcDTc9Vk&ab_channel=Netflix
          setTrailerUrl(urlParams.get('v') );
        // console.log( urlParams.get("ab_channel"));
      }).catch((error) => console.log(error))
    } 
  }
  
  // console.log(movies);

  return (
    <div className='row'>
      <h2>{title}</h2>
      <div className='row_posters '>
        {movies.map((movie) => (
         <img 
         key = {movie.id}
         onClick = {() => handleClick(movie)}
         className = {`row_poster ${isLargeRow && "row_posterLarge"}`}
         src= {`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
         alt= {movie.name} >
         </img> 
        ))}
      </div>
      {trailerUrl && <YouTube videoId = {trailerUrl} opts={opts} /> }
    </div>
  )
}

export default Row;